import { Routes } from '@angular/router';

import { AuthGuard } from '@core/guards';
import { WorkspaceStateService } from '@core/services';
import { AuthLayoutComponent } from '@ui/layouts/auth-layout/auth-layout.component';
import { WorkspaceLayoutComponent } from '@ui/layouts/workspace-layout/workspace-layout.component';

export const routes: Routes = [
    {
        path: '',
        component: AuthLayoutComponent, 
        loadChildren: () => import('@features/auth/routes'),
    },
    {
        path: '',
        canActivate: [AuthGuard],
        component: WorkspaceLayoutComponent,
        providers: [WorkspaceStateService],
        children: [
            {
                path: 'files', 
                loadChildren: () => import('@features/file/routes'),
            },
            {
                path: 'account', 
                loadChildren: () => import('@features/account/routes'),
            },
        ]
    },
];
